/* Free Gift Popup logic for Dawn
 * - ONE free ($0) gift PER BRAND (Awayuki / Haiken)
 * - Gifts are tiered by qualifying-bottle count (minBottles / maxBottles)
 * - Crossing a tier auto-removes the now-ineligible gift and re-prompts
 * - Removes a brand's gift entirely when its bottles leave the cart
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('GiftPopupData');
  if (!dataEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[gift-popup] bad config JSON', e);
    return;
  }

  var GIFTS = (CONFIG.gifts || []).filter(function (g) { return g.variantId; });
  if (!GIFTS.length) return;

  var GIFT_BY_VARIANT = {};
  var GIFT_HANDLES = new Set();
  GIFTS.forEach(function (g) {
    GIFT_BY_VARIANT[g.variantId] = g;
    GIFT_HANDLES.add(g.handle);
  });

  var BRANDS = ['awayuki', 'haiken'];
  var BRAND_LABEL = { awayuki: 'Awayuki', haiken: 'Haiken' };

  function qSet(brand, kind) {
    var q = CONFIG.qualifiers || {};
    return new Set(((q[brand] && q[brand][kind]) || []).filter(Boolean));
  }
  var QUAL = {
    awayuki: { single: qSet('awayuki', 'single'), double: qSet('awayuki', 'double') },
    haiken: { single: qSet('haiken', 'single'), double: qSet('haiken', 'double') }
  };

  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';

  // ---- cart helpers -------------------------------------------------------
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function addGift(variantId) {
    return postJSON(ADD_URL + '.js', { items: [{ id: variantId, quantity: 1 }] });
  }
  function changeQty(variantId, qty) {
    return postJSON(CHANGE_URL + '.js', { id: variantId, quantity: qty });
  }
  function runOps(ops) {
    // ops: array of functions returning promises, run sequentially
    return ops.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve());
  }

  function refreshCartUI() {
    return getCart().then(function (cart) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-popup', cartData: cart });
        }
      } catch (e) { /* noop */ }
      return fetch(CART_URL + '?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var el = document.getElementById('cart-icon-bubble');
          if (el) el.innerHTML = html;
        })
        .catch(function () {});
    });
  }

  // ---- rule evaluation ----------------------------------------------------
  function countBottles(cart) {
    var counts = { awayuki: 0, haiken: 0 };
    (cart.items || []).forEach(function (it) {
      var h = it.handle;
      var qty = it.quantity || 0;
      BRANDS.forEach(function (b) {
        if (QUAL[b].single.has(h)) counts[b] += qty;
        else if (QUAL[b].double.has(h)) counts[b] += qty * 2;
      });
    });
    return counts;
  }

  function giftItemsInCart(cart) {
    return (cart.items || []).filter(function (it) {
      return GIFT_BY_VARIANT[it.variant_id] || GIFT_HANDLES.has(it.handle);
    });
  }

  function brandOfItem(it) {
    var g = GIFT_BY_VARIANT[it.variant_id];
    if (g) return g.brand;
    // fallback by handle
    var found = GIFTS.filter(function (x) { return x.handle === it.handle; })[0];
    return found ? found.brand : null;
  }

  function eligibleForBrand(brand, count) {
    return GIFTS.filter(function (g) {
      return g.brand === brand &&
        count >= g.minBottles &&
        (g.maxBottles == null || count <= g.maxBottles);
    });
  }

  // ---- UI -----------------------------------------------------------------
  var popup = document.getElementById('GiftPopup');
  var grid = document.getElementById('GiftPopup-grid');
  var addBtn = document.getElementById('GiftPopup-add');
  var subtitle = popup ? popup.querySelector('.gift-popup__subtitle') : null;
  var trigger = document.getElementById('GiftTrigger');

  var currentGroups = [];   // [{brand, gifts:[...], current:variantId|null}]
  var selection = {};       // { brand: variantId }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateAddState() {
    if (!addBtn) return;
    var ready = currentGroups.length > 0 && currentGroups.every(function (g) {
      return !!selection[g.brand];
    });
    addBtn.disabled = !ready;
  }

  function renderGroups(groups) {
    currentGroups = groups;
    selection = {};
    groups.forEach(function (g) { if (g.current) selection[g.brand] = g.current; });

    if (!grid) return;

    grid.innerHTML = groups.map(function (g) {
      var cards = g.gifts.map(function (gift) {
        var isSel = gift.variantId === selection[g.brand];
        var media = gift.image
          ? '<img src="' + gift.image + '" alt="" loading="lazy">'
          : '<span class="gift-card__noimg">&#127873;</span>';
        return (
          '<label class="gift-card' + (isSel ? ' is-selected' : '') + '">' +
          '<input type="radio" name="giftChoice-' + g.brand + '" value="' + gift.variantId + '"' + (isSel ? ' checked' : '') + '>' +
          '<span class="gift-card__media">' + media + '</span>' +
          '<span class="gift-card__title">' + escapeHtml(gift.title) + '</span>' +
          '</label>'
        );
      }).join('');
      var heading = groups.length > 1
        ? '<h3 class="gift-popup__group-title">Your ' + escapeHtml(BRAND_LABEL[g.brand] || g.brand) + ' gift</h3>'
        : '';
      return '<div class="gift-popup__group" data-brand="' + g.brand + '">' + heading +
        '<div class="gift-popup__cards">' + cards + '</div></div>';
    }).join('');

    Array.prototype.forEach.call(grid.querySelectorAll('input[type="radio"]'), function (inp) {
      inp.addEventListener('change', function () {
        var brand = inp.name.replace('giftChoice-', '');
        selection[brand] = Number(inp.value);
        var groupEl = inp.closest('.gift-popup__group');
        if (groupEl) {
          Array.prototype.forEach.call(groupEl.querySelectorAll('.gift-card'), function (c) {
            c.classList.remove('is-selected');
          });
          var card = inp.closest('.gift-card');
          if (card) card.classList.add('is-selected');
        }
        updateAddState();
      });
    });

    if (subtitle) {
      var anyMissing = groups.some(function (g) { return !g.current; });
      subtitle.textContent = anyMissing
        ? 'You’ve unlocked a gift with purchase. Make your choice below:'
        : 'Update your gift selection below:';
    }
    updateAddState();
  }

  function openPopup() { if (popup) { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); document.body.classList.add('gift-popup-open'); } }
  function closePopup() { if (popup) { popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); document.body.classList.remove('gift-popup-open'); } }

  function showTrigger(changeMode) {
    if (!trigger) return;
    var label = trigger.querySelector('.gift-trigger__label');
    if (label) label.textContent = changeMode ? 'Change your gift' : 'Choose your gift';
    trigger.hidden = false;
  }
  function hideTrigger() { if (trigger) trigger.hidden = true; }

  // ---- main loop ----------------------------------------------------------
  var processing = false;
  var pendingAuto = false;
  var evalTimer = null;
  var lastEligCount = {};    // brand -> eligible gift count at previous eval
  var evaluatedOnce = false; // don't treat the first (page-load) eval as an "unlock"

  function scheduleEvaluate(auto) {
    pendingAuto = pendingAuto || auto;
    clearTimeout(evalTimer);
    evalTimer = setTimeout(function () {
      var a = pendingAuto;
      pendingAuto = false;
      evaluate(a);
    }, 250);
  }

  function evaluate(autoOpen) {
    if (processing) { scheduleEvaluate(autoOpen); return Promise.resolve(); }
    processing = true;

    return getCart().then(function (cart) {
      var counts = countBottles(cart);
      var giftItems = giftItemsInCart(cart);
      var ops = [];          // mutations to run
      var groups = [];       // brands still needing / offering a choice
      var reprompt = false;  // a tier change forced a removal
      var newUnlock = false; // a higher bottle count made NEW gift options available

      BRANDS.forEach(function (brand) {
        var count = counts[brand] || 0;
        var brandGifts = giftItems.filter(function (it) { return brandOfItem(it) === brand; });

        if (count < 1) {
          // brand no longer in cart -> strip its gift(s)
          brandGifts.forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
          lastEligCount[brand] = 0;
          return;
        }

        var elig = eligibleForBrand(brand, count);
        if (evaluatedOnce && elig.length > (lastEligCount[brand] || 0)) newUnlock = true;
        lastEligCount[brand] = elig.length;
        var eligIds = new Set(elig.map(function (g) { return g.variantId; }));
        var valid = brandGifts.filter(function (it) { return eligIds.has(it.variant_id); });
        var invalid = brandGifts.filter(function (it) { return !eligIds.has(it.variant_id); });

        // remove wrong-tier gifts and any duplicate valid gifts
        invalid.forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
        if (invalid.length) reprompt = true;

        var keep = valid[0] || null;
        valid.slice(1).forEach(function (it) { ops.push(function () { return changeQty(it.key, 0); }); });
        if (keep && keep.quantity !== 1) {
          ops.push(function () { return changeQty(keep.key, 1); });
        }

        if (elig.length) {
          groups.push({ brand: brand, gifts: elig, current: keep ? keep.variant_id : null });
        }
      });

      var mutated = ops.length > 0;

      function finish() {
        if (groups.length === 0) {
          hideTrigger();
          closePopup();
        } else {
          renderGroups(groups);
          var needChoice = groups.some(function (g) { return !g.current; });
          showTrigger(!needChoice);
          if ((needChoice && (autoOpen || reprompt)) || newUnlock) openPopup();
          else if (!needChoice) { /* all chosen: leave popup state as-is */ }
        }
      }

      return runOps(ops)
        .then(function () { return mutated ? refreshCartUI() : null; })
        .then(finish);
    }).catch(function (e) {
      console.error('[gift-popup]', e);
    }).then(function () {
      processing = false;
      evaluatedOnce = true;
    });
  }

  // ---- wire up events -----------------------------------------------------
  if (popup) {
    Array.prototype.forEach.call(popup.querySelectorAll('[data-gift-close]'), function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  }

  if (trigger) trigger.addEventListener('click', openPopup);

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      // Authoritative reconcile: for each brand being chosen, keep ONLY the
      // selected gift and remove every other gift of that brand — including a
      // stale wrong-tier gift (e.g. the 1-bottle gift when now at 2 bottles).
      getCart()
        .then(function (cart) {
          var giftItems = giftItemsInCart(cart);
          var ops = [];
          currentGroups.forEach(function (g) {
            var desired = selection[g.brand];
            if (!desired) return;
            var brandGifts = giftItems.filter(function (it) { return brandOfItem(it) === g.brand; });
            var keptDesired = false;
            brandGifts.forEach(function (it) {
              if (it.variant_id === desired && !keptDesired) {
                keptDesired = true;
                if (it.quantity !== 1) ops.push(function () { return changeQty(it.key, 1); });
              } else {
                ops.push(function () { return changeQty(it.key, 0); });
              }
            });
            if (!keptDesired) ops.push(function () { return addGift(desired); });
          });
          return runOps(ops);
        })
        .then(refreshCartUI)
        .then(function () { closePopup(); return evaluate(false); })
        .catch(function (e) {
          console.error('[gift-popup] add failed', e);
          addBtn.disabled = false;
        });
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'gift-popup') return;
      var auto = !(event && event.source === 'cart-items');
      scheduleEvaluate(auto);
    });
  }

  evaluate(false);
})();
